const MetricsIcon = (props) => (
	<svg
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12.2426 7.75735L8 9.34834L3.75736 7.75735L5.34835 12L3.75736 16.2426L8 14.6516L12.2426 16.2426L10.6517 12" />
		<path d="M19.682 4.31803L16.5 5.51127L13.318 4.31803L14.5113 7.50001L13.318 10.682L16.5 9.48875L19.682 10.682L18.4887 7.50001" />
		<path d="M19.273 15.091L17.182 15.8751L15.091 15.091L15.8751 17.182L15.091 19.273L17.182 18.4888L19.273 19.273L18.4889 17.182" />
	</svg>
)

export default MetricsIcon